import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { fetchGalleryPhotos } from "../../../services/mediaApi";
import { optimizeCloudinaryUrl } from "../../../utils/cloudinaryUrl";
import "./photos.css";

const Photos = () => {
  const navigate = useNavigate();

  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "https://placehold.co/300x300?text=No+Image";
    return optimizeCloudinaryUrl(imagePath, 1200);
  };

  const fetchPhotos = async () => {
    setLoading(true);
    setError(null);
    try {
      const { images } = await fetchGalleryPhotos();
      if (images.length > 0) {
        setPhotos(images);
      } else {
        setError("No gallery images found.");
      }
    } catch (err) {
      setError(err.message || "Failed to load gallery.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  return (
    <div className="photos-page">
      <header className="photos-header">
        <h2 className="heading-unified">Gallery</h2>
      </header>

      <div className="photos-gallery container">
        {loading ? (
          <div className="loading-state">Loading gallery...</div>
        ) : error ? (
          <div className="error-state">
            <p>{error}</p>
            <small>If you see a Network Error, make sure your backend terminal is running.</small>
          </div>
        ) : photos.length > 0 ? (
          photos.map((photo, index) => (
            <div
              key={photo._id || photo.id || `gallery-photo-${index}`}
              className="photo-card"
            >
              <div className="card-image-wrapper">
                <img
                  src={getImageUrl(photo.imageUrl || photo.url)}
                  alt={photo.title || "Gallery Image"}
                  width="300"
                  height="300"
                  loading="lazy"
                  onError={(e) => {
                    if (!e.target.src.includes('unsplash.com')) {
                      e.target.src = "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=300&h=300&auto=format&fit=crop";
                      console.warn("Gallery page image failed to load, using fallback");
                    }
                  }}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="no-photos">No photos found in Cloudinary gallery.</div>
        )}
      </div>

      <div className="bottom-actions">
        <button className="back-btn-bottom" onClick={() => navigate(-1)}>
          ← Back to Social Hub
        </button>
      </div>
    </div>
  );
};

export default Photos;
